// extracted by mini-css-extract-plugin
module.exports = {"tags":"F_cr","tags__item":"F_cs"};